// メニューのTurbolinksイベントをハンドリングする関数
export function handleMenuTurbolinks() {
    document.addEventListener('turbolinks:load', () => {
        setupMenus();
    });

    document.addEventListener('turbolinks:before-cache', () => {
        teardownMenus();
    });
}

// メニュー項目にホバーイベントを設定する関数
function setupMenus() {
    // .master-menus の li要素にホバーイベントを設定
    $(".master-menus").children("li").hover(
        function () { // マウスエンター時
        $(this).children("ul").stop().slideDown(180);
        },
        function () { // マウスリーブ時
        $(this).children("ul").stop().slideUp(180);
        }
);

// .global_nav の li要素にホバーイベントを設定
    $(".global_nav").children("li").hover(
        function () { // マウスエンター時
        $(this).children("ul").stop().slideDown(180);
        },
        function () { // マウスリーブ時
        $(this).children("ul").stop().slideUp(180);
        }
    );
}

// メニュー項目のホバーイベントを解除する関数
function teardownMenus() {
    // .master-menus の li要素からホバーイベントを解除
    $(".master-menus").children("li").off("mouseenter mouseleave");

    // .global_nav の li要素からホバーイベントを解除
    $(".global_nav").children("li").off("mouseenter mouseleave");
}
